// List of all trainings Module Selectors
export const getDefaultFilters = ({ trainingCategoryList }) => trainingCategoryList.searchFilter;
export const getListPageTitle = ({ trainingCategoryList }) => trainingCategoryList.searchLabel;
export const getListAlertModal = ({ trainingCategoryList }) => trainingCategoryList.alert;
export const getListConfirmModal = ({ trainingCategoryList }) => trainingCategoryList.confirmModal;

// Table selectors
export const getCurrentPage = ({ trainingCategoryList }) => trainingCategoryList.searchFilter.Pagination.Page;
export const getSortModel = ({ trainingCategoryList }) => trainingCategoryList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ trainingCategoryList }) => trainingCategoryList.resultTable.rowsPerPage;
export const isTableLoading = ({ trainingCategoryList }) => trainingCategoryList.resultTable.loading;
export const getTableData = ({ trainingCategoryList }) => trainingCategoryList.resultTable.data;
export const getTotalCount = ({ trainingCategoryList }) => trainingCategoryList.resultTable.totalCount;
export const getTableSelectedRows = ({ trainingCategoryList }) => trainingCategoryList.resultTable.selectedRows;


// Training Master Module Add Form
export const getAddFormData = ({ trainingCategoryList }) => trainingCategoryList.addForm;
export const getAlertModalData = ({ trainingCategoryList }) => trainingCategoryList.alert;
export const getShowLoading = ({ trainingCategoryList }) => trainingCategoryList.loading;
export const getUpdateValues = ({ trainingCategoryList }) => trainingCategoryList.updateValues;

export const validateAddForm = (values) => {
    let errors = {};

    if (values.applicantID === 0) {
        errors[`trainingCategory`] = 'Training Category is required!'
    }

    if (values.interviewer === 0) {
        errors[`trainingName`] = 'Training Name is required!'
    }

    return errors;
}